import { useIntl } from './useIntl'

type Priority = uui.domain.server.rm.BaseOrder['priority']

export function useOrderPriorityTexts() {
  const { translate } = useIntl()

  function getPriorityText(priority: Priority) {
    return translate({
      id: PRIORITY_INTL_MAP_ID[PRIORITY_MAP_BY_VALUE[priority]],
    })
  }

  return {
    getPriorityText,
  }
}

const PRIORITY_MAP_BY_VALUE = {
  [-20]: 'lowest',
  [-10]: 'lower',
  [0]: 'normal',
  [10]: 'higher',
  [20]: 'highest',
}

const PRIORITY_INTL_MAP_ID: Record<string, uui.domain.intl.LocalizationIdentifier> = {
  lowest: 'orders.priority.lowest',
  lower: 'orders.priority.lower',
  normal: 'orders.priority.normal',
  higher: 'orders.priority.higher',
  highest: 'orders.priority.highest',
}
